import { Badge, Flex, Typography } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const CleaningAreaRowDragHandle = styled.span<{
  $active: boolean;
  $isDragging?: boolean;
  $isDraggingSource?: boolean;
}>`
  ${({ theme: { kcc }, $active, $isDragging, $isDraggingSource }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    width: ${kcc.size.S400}px;
    flex-shrink: 0;
    /* #E3E3E3 is a one-off — not a KCC token — only used to distinguish the floating drag-overlay
       clone's handle background from the resting/active states below it. */
    background-color: ${($isDragging && '#E3E3E3') || ($active && kcc.colors.GRAY_50) || 'transparent'};
    cursor: ${$active ? 'grab' : 'default'};

    .svg-icon {
      width: 24px;
      height: 24px;
      visibility: ${$active ? 'visible' : 'hidden'};
      opacity: ${$isDraggingSource ? 0.35 : 1};
    }
  `}
`;

export const CleaningAreaRowContent = styled(Flex)`
  ${(): FlattenSimpleInterpolation => css`
    flex: 1;
    min-width: 0;
  `}
`;

export const CleaningAreaRowCheckboxWrapper = styled.span<{ $isDraggingSource?: boolean }>`
  ${({ theme: { kcc }, $isDraggingSource }): FlattenSimpleInterpolation => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-inline-start: ${kcc.spacing.BASE};

    ${$isDraggingSource &&
    css`
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${kcc.colors.GRAY_200} !important;
        border-color: ${kcc.colors.GRAY_200} !important;

        &::after {
          background-color: ${kcc.colors.GRAY_400} !important;
        }
      }
    `}
  `}
`;

export const CleaningAreaRowText = styled(Typography.Text)<{ $isSelected: boolean; $isDraggingSource?: boolean }>`
  ${({ theme: { kcc }, $isSelected, $isDraggingSource }): FlattenSimpleInterpolation => css`
    min-width: 0;

    &.ant-typography {
      font-weight: ${$isSelected ? kcc.typography.FONT_WEIGHT.EXTRA_BOLD : kcc.typography.FONT_WEIGHT.REGULAR};
      opacity: ${$isDraggingSource ? 0.35 : 1};
    }
  `}
`;

export const CleaningAreaOrderBadge = styled(Badge)<{ $isDraggingSource?: boolean }>`
  ${({ theme: { kcc }, $isDraggingSource }): FlattenSimpleInterpolation => css`
    flex-shrink: 0;
    margin-inline-start: ${kcc.spacing.SM};
    margin-inline-end: ${kcc.spacing.XS};

    .ant-badge-count {
      min-width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      padding: 0;
      box-shadow: none;
      background-color: ${$isDraggingSource ? kcc.colors.GRAY_200 : kcc.colors.BLACK};
      color: ${kcc.colors.GRAY_50};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    }

    .ant-scroll-number-only {
      padding-top: 1px;
    }
  `}
`;
